import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=7fe69fb0&scoped=true&"
import script from "./base_info.vue?vue&type=script&lang=js&"
export * from "./base_info.vue?vue&type=script&lang=js&"
import style0 from "./base_info.vue?vue&type=style&index=0&id=7fe69fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe69fb0",
  null
  
)

export default component.exports